import { Link } from '@tanstack/react-router';
import { Inbox } from 'lucide-react';
import { useInboxSummary } from './inbox';

/** Header button with the number of documents waiting for the user's approval. */
export function InboxButton() {
  const { data } = useInboxSummary();
  const n = data?.total ?? 0;
  return (
    <Link
      to="/inbox"
      className="fx-tip relative flex size-10 items-center justify-center rounded-xl border border-border bg-surface text-fg-muted transition-all duration-200 hover:-translate-y-px hover:border-accent hover:text-primary hover:shadow-(--shadow-card) active:scale-95"
      aria-label={n ? `Approval inbox, ${n} waiting` : 'Approval inbox'}
      data-tip="Approval inbox"
    >
      <Inbox className="size-[18px]" />
      {n > 0 && (
        <span key={n} className="tabular fx-attn absolute -top-1.5 -right-1.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#d9480f] px-1 text-[10px] font-bold text-white shadow-[0_0_0_2px_var(--color-surface)]">
          {n > 99 ? '99+' : n}
        </span>
      )}
    </Link>
  );
}
